import React from "react";
import StageBookViewer from "../components/StageBookViewer";
import { META, CHAPTERS } from "../data/ks4_book";

export default function Ks4BookViewer() {
  return (
    <StageBookViewer
      meta={META}
      chapters={CHAPTERS}
      accent="#001B3A"
      testIdPrefix="ks4"
      comingSoonNote="9 further chapters are in development for Key Stage 4 — Source-based Inquiry and Buddhism & Citizenship."
    />
  );
}
